import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DoubleEmail, { DoubleEmailValidation } from '../DoubleEmail';
import DoublePassword, { DoublePasswordValidation } from '../DoublePassword';
import SectionHeader from '../../Basic/SectionHeader';
import TextBox from '../../Basic/TextBox';
import AccountVerify from './AccountVerify';
import EmailNotificationConfirm from './EmailNotificationConfirm';
import FortisButton from '../../Basic/FortisButton';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import LinkButton from '../../Basic/LinkButton';
import util from '../../../lib/util';
import { browserHistory } from 'react-router';
class CreateProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = { userId: null, email: null };
    {/*Here we can check if the state.form.emailAddress has any value, put it for profileEmailAddress(Communication offer) */ }
  }
  componentWillReceiveProps(p) {
    if (p.email && p.email !== this.state.email) {
      let model = { Email: p.email };
      p.validateEmail(model);
      this.setState({ email: p.email });
    }
    if (p.userId && p.userId !== this.state.userId) {
      let model = { Username: p.userId };
      p.validateUserName(model);
      this.setState({ userId: p.userId });
    }
    if (p.user && p.user.isAuthenticated && p.isRegister) {
      browserHistory.push('/dashboard');
    }
  }

  onCreateProfileClick = () => {
    const p = this.props;
    let validators = [
      ...DoubleEmailValidation('profileEmailAddress'),
      ['profileUserId', p => p.profileUserId, "User ID"],
      ...DoublePasswordValidation('profilePassword'),
      ['profileNotificationEmail', p => p.profileNotificationEmail == 1, "#required"]
    ];
    if (util.validate(validators, p.form, p.formError)) {
      let model = {
        Username: p.userId,
        Email: p.email,
        Password: p.password,
        BpNumber: p.isRegister ? p.user.bpNumber : p.bpNumber,
        ConfirmPassword: p.password,
        IsEmailNotificationAllowed: (p.emailNotification == 1),
        IsEmailNewsAllowed: (p.emailNews == 1)
      };
      p.createProfile(model);
    }
  }
  render() {
    const p = this.props;
    const lookup = window.osa && window.osa.commonLookup && window.osa.commonLookup.userProfile;
    const invalidUser = lookup && lookup.errors.invalidUser;
    const invalidEmail = lookup && lookup.errors.invalidEmail;
    const invalidPassword = lookup && lookup.errors.invalidPassword;
    const colSpan = p.isRegister ? "col-sm-12" : "col-sm-4";
    return (
      <div>
        <div className="col-sm-12" >
          {
            p.isRegister ? <h3 className="panel-title text-primary">   Create your online profile</h3> : null
          }
        </div>
        <div className="col-sm-12" >
          <div className="form-group">
            <SectionHeader title={lookup && lookup.userIdInfo} />
            <p>{lookup && lookup.userIdTip}</p>
            {
              p.isRegister ?
                <p>Important: the online profile you create here to track your service request is separate from an <a href="https://accounts.fortisbc.com/">Account Online</a> profile.</p>
                : null
            }
            <div className="row">
              <div className={colSpan}>
                <DoubleEmail name="profileEmailAddress" title1={lookup && lookup.emailTitle1} title2={lookup && lookup.emailTitle2} required disabled={p.isInvitedFromCafe} />
                {p.isInvalidEmail ?
                  <div className="control-label has-error error-msg">
                    {invalidEmail}
                  </div>
                  : null
                }
              </div>
            </div>
            <div className="row">
              <div className={colSpan}>
                <TextBox title={lookup && lookup.userIdTitle} name="profileUserId" required errorMsg="User ID is required" />
                {p.isInvalidUserName ?
                  <div className="control-label has-error error-msg">
                    {invalidUser}
                  </div>
                  : null
                }
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12" >
          <div className="form-group">
            <SectionHeader title={lookup && lookup.passwordTitle} />
            <p> {lookup && lookup.passwordTip}</p>
            <div className="row">
              <div className={colSpan}>
                <DoublePassword name="profilePassword" required />
                {p.isInvalidPassword ?
                  <div className="control-label has-error error-msg">
                    {invalidPassword}
                  </div>
                  : null
                }
              </div>
            </div>
          </div>
        </div>
        {p.isRegister ? <AccountVerify /> : null}
        <EmailNotificationConfirm {...p} />
        <div className="col-sm-12" >
          <div className="form-group">
            <ButtonToolbar style={{display: "inline-flex"}}>
              {!this.props.isRegister ?
                <LinkButton text="Back" onClick={p.onBackClick} />
                :
                null
              }
              <FortisButton text="Create profile" onClick={this.onCreateProfileClick} />
              {!this.props.isRegister ?
                <LinkButton text="Cancel" onClick={p.onCancelClick} />
                :
                <FortisButton text="Cancel" onClick={() => browserHistory.push('/login')}/>
              }
            </ButtonToolbar>
          </div>
        </div>
      </div>

    );
  }
}

CreateProfile.propTypes = {
  email: PropTypes.string,
  userId: PropTypes.string,
  password: PropTypes.string,
  bpNumber: PropTypes.string,
  emailNotification: PropTypes.string,
  emailNews: PropTypes.string,
  isInvalidUserName: PropTypes.bool,
  isInvalidEmail: PropTypes.bool,
  isInvalidPassword: PropTypes.bool,
  isInvitedFromCafe: PropTypes.bool,
  isRegister: PropTypes.bool,
  form: PropTypes.object,
  user: PropTypes.object
};

function mapStateToProps(state) {
  return {
    form: state.form,
    email: state.form.profileEmailAddress,
    userId: state.form.profileUserId,
    password: state.form.profilePassword,
    emailNotification: state.form.profileNotificationEmail,
    emailNews: state.form.profileUpdatesEmail,
    isInvalidUserName: state.gas.invalidUserName,
    isInvalidEmail: state.gas.invalidEmail,
    isInvalidPassword: state.gas.invalidPassword,
    user: state.gas.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    validateEmail: (model) => dispatch({ type: 'VALIDATE_EMAIL', model }),
    validateUserName: (model) => dispatch({ type: 'VALIDATE_USERNAME', model }),
    createProfile: (model) => dispatch({ type: 'CREATE_PROFILE', model })
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateProfile);

